webpackJsonp([162944170585655],{

/***/ 63:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var pageData = [{
	  order: 1,
	  title: "Lagspelare",
	  heading: "Lagspelare",
	  subheading: "Alla kan inte vara Zlatan.",
	  dl1: "Ibland betyder lagspelare bara att man ska jobba i ett team.",
	  dl2: "Alla i ett lag har olika positioner. En målvakt och en anfallare har inte samma uppgifter på planen.",
	  navTitle: "",
	  link: "/lagspelare/"
	}, {
	  order: 2,
	  title: "Quiz",
	  heading: "Lagspelare",
	  subheading: "Metaforer kan uppfattas olika och vara svåra att förstå.",
	  link: "/lagspelare/02/",
	  quizHeading: "Hur är en lagspelare på din arbetsplats?",
	  quizAnswer1: {
	    content: "Får personer av olika ståndpunkt att komma överens",
	    note: "Relationskompetens"
	  },
	  quizAnswer2: {
	    content: "Handlar konstruktivt vid motgångar",
	    note: "Anpassningskompetens"
	  },
	  quizAnswer3: {
	    content: "Arbetar med andra för att gemensamt lösa en uppgift",
	    note: "Relationskompetens"
	  },
	  quizAnswer4: {
	    content: "Bygger upp och stärker relationer",
	    note: "Relationskompetens"
	  },
	  modal: {
	    heading: "Lagspelare",
	    subheading: "Grattis!",
	    body: "Nu har du ökat möjligheten att hitta din organisations egna stjärnspelare.",
	    buttonText: "Fortsätt jakten!"
	  }
	}];
	
	exports.default = pageData;
	module.exports = exports["default"];

/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(24);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lagspelare = __webpack_require__(63);
	
	var _lagspelare2 = _interopRequireDefault(_lagspelare);
	
	var _Content = __webpack_require__(9);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _BottomNav = __webpack_require__(28);
	
	var _BottomNav2 = _interopRequireDefault(_BottomNav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Main = function Main(_ref) {
	  var currentPageNum = _ref.currentPageNum,
	      tutorial = _ref.tutorial,
	      quiz = _ref.quiz,
	      hasNav = _ref.hasNav;
	
	  // Get page data from data/pageData.js
	  var currentPageData = _lagspelare2.default.find(function (page) {
	    return page.order === currentPageNum;
	  });
	  return _react2.default.createElement(
	    'div',
	    { className: 'Shell' },
	    _react2.default.createElement(
	      _Content2.default,
	      { header: true },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          _reactHelmet.Helmet,
	          null,
	          _react2.default.createElement(
	            'title',
	            null,
	            'Jakten | ' + currentPageData.title
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'main__content' },
	          tutorial
	        ),
	        quiz ? _react2.default.createElement(
	          'div',
	          { className: 'quiz-section' },
	          _react2.default.createElement(
	            'div',
	            { className: 'quiz__content' },
	            quiz
	          )
	        ) : null,
	        hasNav ? _react2.default.createElement(_BottomNav2.default, {
	          navTitle: currentPageData.navTitle,
	          currentPageNum: currentPageNum,
	          pageData: _lagspelare2.default
	        }) : null
	      )
	    )
	  );
	};
	
	Main.propTypes = {
	  tutorial: _propTypes2.default.node.isRequired,
	  quiz: _propTypes2.default.node,
	  hasNav: _propTypes2.default.bool,
	  currentPageNum: _propTypes2.default.number.isRequired
	};
	
	Main.defaultProps = {
	  hasNav: true,
	  quiz: ''
	};
	
	exports.default = Main;
	module.exports = exports['default'];

/***/ }),

/***/ 205:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 422:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactFeather = __webpack_require__(50);
	
	var _Main = __webpack_require__(116);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _floskelLagspelare = __webpack_require__(205);
	
	var _floskelLagspelare2 = _interopRequireDefault(_floskelLagspelare);
	
	var _lagspelare = __webpack_require__(63);
	
	var _lagspelare2 = _interopRequireDefault(_lagspelare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var currentPageData = _lagspelare2.default.find(function (page) {
	  return page.order === 1;
	});
	
	var Tutorial = function Tutorial() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'SectionHeader' },
	      _react2.default.createElement(
	        'span',
	        { className: 'SectionHeader__text' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'SectionHeader__title' },
	          currentPageData.heading
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'lead' },
	          currentPageData.subheading
	        )
	      ),
	      _react2.default.createElement('img', { alt: '', src: _floskelLagspelare2.default, className: 'SectionHeader__graphic' })
	    ),
	    _react2.default.createElement(
	      'ul',
	      { className: 'DescriptionList' },
	      _react2.default.createElement(
	        'li',
	        { className: 'DescriptionList__item' },
	        _react2.default.createElement(_reactFeather.Square, { className: 'DescriptionList__graphic' }),
	        _react2.default.createElement(
	          'span',
	          { className: 'DescriptionList__text' },
	          currentPageData.dl1
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        { className: 'DescriptionList__item' },
	        _react2.default.createElement(_reactFeather.Square, { className: 'DescriptionList__graphic' }),
	        _react2.default.createElement(
	          'span',
	          { className: 'DescriptionList__text' },
	          currentPageData.dl2
	        )
	      )
	    )
	  );
	};
	
	exports.default = function () {
	  return _react2.default.createElement(_Main2.default, { currentPageNum: 1, tutorial: _react2.default.createElement(Tutorial, null), hero: false });
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-lagspelare-index-js-b4fc5ca1f618748068e2.js